var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"burger-wrapper",on:{"click":_vm.toggleNav}},[_c('button',{staticClass:"burger",class:{'is-active': _vm.burgerActive}},[_vm._v("\n    Mobile menu\n    "),_c('span'),_c('span'),_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }